import React from "react";

// Static SVG assets (CRA emits these as hashed URLs in build/static/media, NOT
// compiled into main.js). Generated by scripts/extract-patterns.mjs from the old
// p1.jsx..p28.jsx. Replaces ~6.8 MB of inline-JSX SVG in the bundle.
import p1 from "./svg/p1.svg";
import p2 from "./svg/p2.svg";
import p3 from "./svg/p3.svg";
import p4 from "./svg/p4.svg";
import p5 from "./svg/p5.svg";
import p6 from "./svg/p6.svg";
import p7 from "./svg/p7.svg";
import p8 from "./svg/p8.svg";
import p9 from "./svg/p9.svg";
import p10 from "./svg/p10.svg";
import p11 from "./svg/p11.svg";
import p12 from "./svg/p12.svg";
import p13 from "./svg/p13.svg";
import p14 from "./svg/p14.svg";
import p15 from "./svg/p15.svg";
import p16 from "./svg/p16.svg";
import p17 from "./svg/p17.svg";
import p18 from "./svg/p18.svg";
import p19 from "./svg/p19.svg";
import p20 from "./svg/p20.svg";
import p21 from "./svg/p21.svg";
import p22 from "./svg/p22.svg";
import p23 from "./svg/p23.svg";
import p24 from "./svg/p24.svg";
import p25 from "./svg/p25.svg";
import p26 from "./svg/p26.svg";
import p27 from "./svg/p27.svg";
import p28 from "./svg/p28.svg";

export const patternUrls = {
  1: p1, 2: p2, 3: p3, 4: p4, 5: p5, 6: p6, 7: p7, 8: p8, 9: p9, 10: p10,
  11: p11, 12: p12, 13: p13, 14: p14, 15: p15, 16: p16, 17: p17, 18: p18,
  19: p19, 20: p20, 21: p21, 22: p22, 23: p23, 24: p24, 25: p25, 26: p26,
  27: p27, 28: p28,
};

/**
 * Pattern — renders one wallpaper pattern by recolouring its static SVG through a
 * CSS mask. The old p*.jsx components drew line-art with stroke={color} inside an
 * <svg width="100%" height="100%" viewBox="0 0 441 441"> (default
 * preserveAspectRatio="xMidYMid meet"). This reproduces that exactly:
 *   - backgroundColor: color   -> the visible LINE-ART colour (was stroke={color})
 *   - maskImage: the SVG       -> alpha channel = the stroke shape (fill="none",
 *                                 opaque strokes -> alpha 1 on the lines only)
 *   - maskSize: contain + center + no-repeat -> matches preserveAspectRatio=meet
 *     (uniform-fit, centred) for the square 441x441 viewBox.
 *
 * Two-colour composability (pattern-background-color ruling, 2026-07-20):
 *   - `color` (#1) = the pattern's LINE-ART colour. It is a LIVE prop -> the div's
 *     backgroundColor, so the art stays fully RECOLORABLE at render time and is
 *     NOT baked into the externalised SVG (the SVG contributes alpha only). The
 *     mask-based fill is exactly the recolor-preserving technique the ruling asks
 *     for; the url() is quoted per the G-51 CSS-url gate.
 *   - `background` (#2) = an OPTIONAL composed background colour rendered BEHIND the
 *     line-art. DEFAULT (omitted) = transparent -> byte/behaviour-identical to the
 *     old render (the caller's container, e.g. SegmentView's PatternContainer /
 *     wallpaperOverlayColor, supplies the background today). The prop exists so the
 *     separate background-defect fix unit can compose pattern-over-bg without
 *     re-architecting this component. Persisted content is unchanged (segments
 *     store patternId + patternColor; no SVG markup is serialised).
 */
export const Pattern = ({ id, color = "black", background }) => {
  const url = patternUrls[id];
  if (!url) return null;
  const mask = `url("${url}") center / contain no-repeat`;
  const artStyle = {
    width: "100%",
    height: "100%",
    backgroundColor: color,
    WebkitMask: mask,
    mask,
  };
  // Default path: line-art over a transparent background (unchanged behaviour).
  if (background == null) {
    return <div aria-hidden="true" style={artStyle} />;
  }
  // Composed path: explicit background colour behind the recolourable line-art.
  return (
    <div
      aria-hidden="true"
      style={{ position: "relative", width: "100%", height: "100%", backgroundColor: background }}
    >
      <div style={{ position: "absolute", inset: 0, ...artStyle }} />
    </div>
  );
};

export default Pattern;
